import { render, staticRenderFns } from "./ViqMessageList.vue?vue&type=template&id=5e2718f3&scoped=true"
import script from "./ViqMessageList.vue?vue&type=script&lang=js"
export * from "./ViqMessageList.vue?vue&type=script&lang=js"
import style0 from "./ViqMessageList.vue?vue&type=style&index=0&id=5e2718f3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2718f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e2718f3')) {
      api.createRecord('5e2718f3', component.options)
    } else {
      api.reload('5e2718f3', component.options)
    }
    module.hot.accept("./ViqMessageList.vue?vue&type=template&id=5e2718f3&scoped=true", function () {
      api.rerender('5e2718f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqMessageList.vue"
export default component.exports